<template>
  <div class="father" style="display: block">
    <div style="" class="dyh-line-group">
      <b class="dyh-line-group-label"> 角 色 管 理</b>
      <el-button type="primary" plain size="small" style="width: 150px" @click="dialogChange(true, 'create')">新 增 角
        色</el-button>
    </div>
    <!-- 表格 -->
    <div class="center body-table dyh-body-table" style="width: 100%;">
      <el-table ref="wtyTableRef" border :fit="true" :data="ugroup_list" size="mini" type="index" height="530px"
        class="show-table" style="height: 100%; width: calc(100% - 20px)" :cell-style="{ padding: '0px 0' }"
        :header-cell-style="{
          height: '20px',
          background: '#409eff',
          color: '#fff',
        }" @row-click="rowClick">
        <el-table-column type="index" align="center" label="行号" :width="50">
        </el-table-column>
        <el-table-column v-for="(item, index) in wtycolumnList" :formatter="item.prop === 'status' ? formatter : null"
          :key="index" :prop="item.prop" :align="item.align" :label="item.label"
          :width="item.width"><!-- formatter 数据过滤 -->
        </el-table-column>

        <el-table-column align="center" width="250px" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="text" style="color: #409eff;" @click="dialogChange(true, 'modify', scope.row)"
              size="mini">修改权限</el-button>
            <el-button style="color:red;" type="text" @click="dialogChange(true, 'del', scope.row)"
              size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 模态框 -->
    <el-dialog :title="dialog_title" :visible.sync="showdialog" width="1200px" style="margin-top: 0px" top="6vh" center>
      <div style="display: flex">
        <el-form label-width="150px" style="min-width: 350px; margin-right: 20px">
          <el-form-item label="角色号：">
            <el-input :disabled="dialog_title == '修改角色'" placeholder="请输入角色号：" v-model="role_info.role_no"></el-input>
          </el-form-item>
          <el-form-item label="角色名称：">
            <el-input placeholder="请输入角色名称：" v-model="role_info.role_name"></el-input>
          </el-form-item>
          <el-form-item label="角色状态：">
            <el-switch v-model="role_info.status" active-text="正常" inactive-text="暂停" :active-value="true"
              :inactive-value="false">
            </el-switch>
          </el-form-item>
        </el-form>
        <all-permission :allp="true" :treeData6="treeData6" :treeData="treeData" ref="allPermissionRef"
          @checkedChange="checkedChange" :height="'400'"></all-permission>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSureClick">确 定</el-button>
        <el-button @click="showdialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { showDialog } from "@/js/public.js";
import {
  //getPermissList,
  //createUserGroup,
  roleQuery,
  setUserGroupPermission,
  deleteUserGroupPermission,
  getServicePermissList,
  getServiceRoleList,
  serviceCreateRole,
  roleSetPermission,
  roleUpdate,
  roleDelete
  //serviceCreateRole
} from "@/api/service.js";
/* eslint-disable */
import {
  getMerchantPermissList,
  MsetUserGroupPermission,
  MdeleteUserGroupPermission,
  mUserRoleGenerate,
  mUserRoleList,
  mUserRoledelete,
  mUserRoleSetRolePermission
} from "@/api/merchant.js";

// import { coerceTruthyValueToArray } from "element-ui/src/utils/util";
import allPermission from "@/components/allPermission";

// import dial
export default {
  name: "wty-userGroup",
  inject: ["reload"],
  props: ["who"],
  created() { },
  async mounted() {
    this.treeData = [];
    this.treeData6 = [];
    this.ugroup_list = [];
    if (this.who === "service") {
      const spl = await getServicePermissList();
      //服务商调用组件
      this.treeData = spl.t2;
      this.treeData6 = spl.t6;
      //TODO:改成角色
      this.getGroupList();
    } else if (this.who === "merchant") {
      const res = await getMerchantPermissList();
      this.treeData = res.t2;
      this.treeData6 = res.t6; //所有可以授权的权限
      this.getGroupList();
    }
  },
  components: {
    allPermission
  },
  data() {
    return {
      /**
       * 表格列
       */
      wtycolumnList: this.setColumn(),
      dialog_title: "", //dialog标题
      showdialog: false, //组设置和修改
      showpermission: false, //权限设置和修改
      //是否新增
      iscreate: true,
      user_group: {
        group_id: "",
        group_no: "",
        group_name: "",
        flag: "1"
      },
      role_info: {
        role_id: "",
        service_no: "",
        role_no: "",
        role_name: "",
        create_id: "",
        create_time: "",
        oper_id: "",
        oper_time: "",
        remark: "",
        status: true
      },
      //角色列表
      ugroup_list: [],
      //选中权限列表
      checked_list: [],
      //老权限列表
      get_checkedlist: [],
      /**
       * 用来循环的权限
       */
      treeData: [],
      /**
       * 所有子权限
       */
      treeData6: []
      /* columnList: [
        {
          prop: "merchant_id",
          align: "center",
          label: "店铺ID",
          width: "200",
          fixed: "left"
        }
      ] */
    };
  },
  methods: {
    /**
     * 数据过滤
     * @param row 返回的行数据
     * @param column 返回的列信息
     */
    formatter(row, column) {
      return row.status === "False" ? '停用' : '正常';
    },
    /**
     * 设置表格列
     */
    setColumn() {
      if (this.who === "merchant") {
        return [
          {
            prop: "roleNo",
            align: "center",
            label: "角色号",
            width: "",
            fixed: false
          },
          {
            prop: "roleName",
            align: "center",
            label: "角色名称",
            width: "",
            fixed: false
          },
          {
            prop: "roleId",
            align: "center",
            label: "角色id",
            width: "",
            fixed: false
          }
        ]
      } else if (this.who === "service") {
        return [
          {
            prop: "role_no",
            align: "center",
            label: "角色号",
            width: "200",
            fixed: false
          },
          {
            prop: "role_name",
            align: "center",
            label: "角色名称",
            width: "200",
            fixed: false
          },
          {
            prop: "create_id",
            align: "center",
            label: "创建者id",
            width: "200",
            fixed: false
          },
          {
            prop: "create_time",
            align: "center",
            label: "创建时间",
            width: "300",
            fixed: false
          }, {
            prop: "oper_id",
            align: "center",
            label: "修改者id",
            width: "200",
            fixed: false
          },
          {
            prop: "oper_time",
            align: "center",
            label: "修改时间",
            width: "200",
            fixed: false
          }, {
            prop: "status",
            align: "center",
            label: "当前状态",
            width: "200",
            fixed: false
          }
        ]
      }
    },
    rowClick() { },
    /**
     * all-permission 组件返回选中的权限
     */
    checkedChange(e) {
      //console.log("组件返回选中的权限", e);
      this.checked_list = e;
      var checked_list = [];
      this.treeData6.forEach((item, index, arr) => {
        if (this.checked_list.includes(item.label)) {
          checked_list.push(item.id);
        }
      });
      /* console.log("选中的权限", checked_list);
      console.log("选中的权限", this.checked_list); */
    },
    /**
     * 获取可提交的权限列表，
     */
    getCheckList() {
      var checked_list = [];
      this.treeData6.forEach((item, index, arr) => {
        if (this.checked_list.includes(item.label)) {
          checked_list.push(item.id);
        }
      });
      return checked_list;
    },
    //高亮显示
    /**
     * @param {String} key 选中的行
     */
    async highLight(group) {
      console.log("group----------------------", group);

      /* if (this.who === "service") {
        this.role_info = group;
      }
       */

      // this.treeShow = true;
      // console.log("checkout_list",this.checked_list);
    },
    //权限设置
    //显示model
    /**
     * 控制dialog显示与隐藏
     * @param {Boolean} value 是否显示dialog
     * @param {"create"|"modify"|"del"|"save"} key 可以选择的值
     * @param {Object} group 选中的组
     */
    async dialogChange(value, key, group) {
      const that = this;
      console.log("argumentsdialogChange", arguments);
      if (value === false) {
        this.showdialog = false;
        return;
      };
      switch (key) {
        case "create":
          console.log("开始新建角色")
          this.showdialog = value;
          this.iscreate = true;
          this.dialog_title = "新建角色";
          this.group_hlight = "-1";
          this.role_info = {
            role_no: "",
            role_name: "",
            status: ""
          };
          this.checked_list = [];
          this.$nextTick(() => {
            console.log(this.checked_list);
            that.$refs.allPermissionRef.changeChecked(this.checked_list);
          });
          break;
        case "modify":
          this.updatedGetCheckList(group);
          this.dialog_title = "修改角色";
          this.showdialog = value;
          this.iscreate = false;
          break;
        case "del":
          /* // this.highLight(group.group_no, group.group_name, group.group_id);
          if (this.who === "service" && group.group_no === "") {
            this.warnMessage("请先选择角色！");
            return;
          } else if (this.who === "merchant" && group.group_id === "") {
            this.warnMessage("请先选择角色！");
            return;
          } */
          if (!await showDialog()) return;
          //删除角色
          if (this.who === "service") {
            console.log("this.role_info--------------------", this.role_info);
            const del_res = await roleDelete(group.role_id);
            if (del_res.state === true) this.successMessage("删除角色成功！");
            this.getGroupList();
          } else if (this.who === "merchant") {
            const del_res = await mUserRoledelete(group.roleId);
            if (del_res.state === true) this.successMessage("删除角色成功！");
            this.getGroupList();
            /* if (this.testR(del_res)) {
              this.ugroup_list = [];
              this.ugroup_list = await MusergroupList();
            } */
          }

          break;
        case "save":
          /* eslint-disable */
          return;
          console.log("save");
          console.log("group", group);
          if (this.who === "service" && group.group_no === "") {
            this.warnMessage("请先选择角色！");
            return;
          } else if (this.who === "merchant" && group.group_no === "") {
            this.warnMessage("请先选择角色！");
            return;
          }
          /* console.log(this.checked_list);
          if (this.checked_list.length == 0) {
            this.warnMessage("请选择权限");
            return;
          } */
          var checked_list = [];
          this.treeData6.forEach((item, index, arr) => {
            if (this.checked_list.includes(item.label)) {
              checked_list.push(item.id);
            }
          });
          // this.showdialog = value;
          //如果原来没授过权
          if (this.get_checkedlist.length === 0) {
            var list = [];
            for (let i = 0; i < checked_list.length; i++) {
              //保存权限
              if (this.who === "service") {
                list.push(
                  setUserGroupPermission({
                    description: this.user_group.group_name,
                    permission_no: checked_list[i],
                    group_no: this.user_group.group_no
                  })
                );
              } else if (this.who === "merchant") {
                list.push(
                  MsetUserGroupPermission({
                    description: this.user_group.group_name,
                    permission_no: checked_list[i],
                    group_id: this.user_group.group_id,
                    group_no: this.user_group.group_no
                  })
                );
              }
            }
            if (list.length > 0) {
              const [...res] = await Promise.all(list);
              if (this.testR(res[0])) this.successMessage("授权成功！");
              this.updatedGetCheckList();
            }
          } else {
            /* var del = [],
              add = []; */
            /* eslint-disable */
            var list = [];
            for (let i = 0; i < this.get_checkedlist.length; i++) {
              if (!checked_list.includes(this.get_checkedlist[i])) {
                if (this.who === "service") {
                  list.push(
                    deleteUserGroupPermission({
                      permission_no: this.get_checkedlist[i],
                      group_no: this.user_group.group_no
                    })
                  );
                } else if (this.who == "merchant") {
                  list.push(
                    MdeleteUserGroupPermission({
                      permission_no: this.get_checkedlist[i],
                      group_id: this.user_group.group_id,
                      group_no: this.user_group.group_no
                    })
                  );
                }
              }
            }
            for (let j = 0; j < checked_list.length; j++) {
              if (!this.get_checkedlist.includes(checked_list[j])) {
                if (this.who == "service") {
                  list.push(
                    setUserGroupPermission({
                      permission_no: checked_list[j],
                      group_no: this.user_group.group_no
                    })
                  );
                } else if (this.who == "merchant") {
                  list.push(
                    MsetUserGroupPermission({
                      permission_no: checked_list[j],
                      group_id: this.user_group.group_id,
                      group_no: this.user_group.group_no
                    })
                  );
                }
              }
            }
            if (list.length > 0) {
              const [...list_res] = await Promise.all(list);
              // console.log(list_res);
              if (this.testR(list_res[0])) {
                this.successMessage("权限修改完成");
                this.updatedGetCheckList();
              }
            }
            /* eslint-enable */
          }
          break;
        /* eslint-enable */
      }
    },
    //创建角色
    /**
     * 点击模态框确定按钮
     */
    async dialogSureClick() {
      if (this.iscreate) {
        if ((this.who === "service" || this.who === 'merchant') && (this.role_info.role_no === "" || this.role_info.role_name === "")) {
          this.warnMessage("请先输入角色号、角色名称");
          return;
        }
        // 创建角色
        let res = {};
        if (this.who === "service") {
          res = await serviceCreateRole(this.role_info);
          console.log("新建角色--------------------------------res：", res);
          if (!res.state) {
            return;
          }
        } else if (this.who === "merchant") {
          /* eslint-disable */
          res = await mUserRoleGenerate(this.role_info, this.getCheckList());
          console.log("店铺创建用户角色", res);
          /* eslint-enable */
        }
        console.log("新建角色res：", res);
        if (this.who === "service") {
          if (res.state === true) this.successMessage(res.message);
          await this.setRolePermission(res.role_id);
          //console.log("授权返回：==========", roleAuthRef);
          /* let data = {
            group_no: res.data.resp_data.group_no,
            group_name: res.data.resp_data.group_name,
            group_id: res.data.resp_data.group_id
          };
          this.highLight(data.group_no, data.group_name, data.group_id);
          console.log("神抽狗的data", data);
          this.dialogChange(false, "save", data);
          this.getGroupList(); */
          this.ugroup_list = [];
          // 获取所有角色
        } else if (this.who === "merchant") {
          if (res.state === true) this.successMessage(res.message);
          // await
        }
        this.getGroupList();
        this.dialogChange(false, "save", this.role_info);
      } else { // 修改角色信息及权限
        if (this.who === "service") { //如果是服务商，需要先修改角色信息再设置权限
          await roleUpdate(this.role_info);
        }
        await this.setRolePermission(this.role_info.role_id);
        // 获取所有角色
        this.getGroupList();
      }
    },
    //TODO: 一会需要看一下
    /**
     * 角色授权
     */
    async setRolePermission(role_id) {
      console.log("角色授权-------", role_id);
      /* eslint-disable */
      const datas = {
        role_id: role_id,
        permission: this.getCheckList(),
        status: this.role_info.status ? 1 : 0
      }
      let result = {};
      if (this.who === "service") {
        result = await roleSetPermission(datas);
      } else if (this.who === "merchant") {
        result = await mUserRoleSetRolePermission(role_id, this.getCheckList());
        console.log("店铺角色授权返回结果", result);
      }
      if (result.state === true) this.successMessage(result.message);
    },
    /**
     * 获取所有授权过的用户
     */
    async getGroupList() {

      this.ugroup_list = [];
      if (this.who === "service") {
        this.ugroup_list = await getServiceRoleList();
      } else if (this.who === "merchant") {
        this.ugroup_list = await mUserRoleList();
      }
      if (this.ugroup_list.length === 0) {
        return;
      }
      this.ugroup_list.sort(function (a, b) {
        return Number(a.role_no) - Number(b.role_no);
      });
      this.dialogChange(false);


    },
    /**
   * 将获取到的权限 更新
   */
    async updatedGetCheckList(roleData) {
      const that = this;
      if (this.who === "service") {
        const res = await roleQuery(roleData.role_id);
        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            this.get_checkedlist.push(res[i]);
          }
        }
        this.checked_list = [];
        this.treeData6.forEach((item, index, array) => {
          if (this.get_checkedlist.includes(item.id)) {
            this.checked_list.push(item.label);
          }
        });
        this.$nextTick(() => {
          that.$refs.allPermissionRef.changeChecked(this.checked_list);
        });
      } else if (this.who === "merchant") {
        this.get_checkedlist = roleData.permssion;
        this.role_info = {
          role_no: roleData.roleNo,
          role_name: roleData.roleName,
          role_id: roleData.roleId,
          status: true
        }
        //保存老的list
        this.checked_list = [];
        this.treeData6.forEach((item, index, array) => {
          if (this.get_checkedlist.includes(item.id)) {
            this.checked_list.push(item.label);
          }
        });
        this.$nextTick(() => {
          that.$refs.allPermissionRef.changeChecked(this.checked_list);
        });
      }
    }
  },

};
</script>
<style scoped lang="less">
/deep/.el-dialog .el-dialog--center {
  margin-top: 2vh !important;
}

.father {
  // padding: 10px;
  height: 100%;
  background-color: transparent;
}

/* .item-main {
  height: 100%;
  min-height: 600px;
} */
.left {
  width: 25%;
}

.ap-fa {
  overflow: hidden;
  // background-color: rgb(228, 66, 66);
  width: auto;
  padding: 0 20px;
  margin-left: 50px;
}

.center {
  width: 35%;

  // background-color: purple;
  .center-title {
    width: 100%;
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 1px solid #ccc;
    padding: 0 20px;

    .add {
      width: 30px;
      height: 30px;
      // background-color: #eaeaea;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      font-weight: 700;
      margin: 10px;
    }
  }

  .center-body {
    height: calc(100% - 100px);

    /* min-height: 580px;
    max-height: 580px; */
    // background-color: pink;
    .center-item {
      width: 90%;
      height: auto;
      max-height: 100px;
      background-color: rgba(0, 0, 0, 0.025);
      margin: 10px;
      float: left;
      display: flex;
      // flex-direction: column;
      // align-items: center;
      justify-content: center;
      border-radius: 10px;
      font-size: 20px;
      cursor: pointer;
      /* .close {
        width: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        background-color:#ff7373;
        border-radius:0 10px 10px 0;

      } */
    }

    .center-item-checked {
      background-color: #409eff;
      color: #fff;
    }
  }
}

.el-checkbox__label {
  font-size: 24px !important;
}

.el-form-item__label {
  font-size: 24px !important;
}

.dialog-footer {
  min-height: 50px !important;
  padding: 10px 0 !important;
}
</style>
